/**
 * Business rule: the firm never publishes its own service prices.
 * Every place a price used to be shown must instead render a call to
 * action asking the visitor to contact the team for a quotation.
 */

export type QuoteLocale = "th" | "en" | "zh" | "ja" | "ko" | "vi" | "id";

export const QUOTE_TEXT: Record<QuoteLocale, string> = {
  th: "สอบถามเจ้าหน้าที่เพื่อขอใบเสนอราคา",
  en: "Contact our team for a quotation",
  zh: "请联系我们的团队获取报价",
  ja: "お見積りは担当チームまでお問い合わせください",
  ko: "견적은 담당팀에 문의해 주세요",
  vi: "Liên hệ đội ngũ của chúng tôi để nhận báo giá",
  id: "Hubungi tim kami untuk mendapatkan penawaran harga",
};

/** Returns the localized quotation CTA text, falling back to Thai. */
export function quoteText(locale?: string): string {
  const key = (locale ?? "th") as QuoteLocale;
  return QUOTE_TEXT[key] ?? QUOTE_TEXT.th;
}
